export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SHOW_MODAL_MSG = 'SHOW_MODAL_MSG';
export const HIDE_MODAL_MSG = 'HIDE_MODAL_MSG';